import { connect } from 'react-redux';
import Spp from '../../../views/Finance/Spp/Spp.view';

function mapStateToProps(state) {
  return {
    user: state.user || {},
  };
}

export default connect(mapStateToProps, null)(Spp);
